import React from 'react';
import { Typography } from '@/components/common';

export const Information: React.FC = () => {
	return (
		<>
			<Typography type="semibold-16" className="text-left">
				Fields to Extract (AI will search for these)
			</Typography>
			<Typography type="regular-14" className="text-left text-gray-35">
				<span className="font-semibold">Database Field: </span>
				Verifies info against your existing platform data and records.
			</Typography>
			<Typography type="regular-14" className="text-left text-gray-35">
				<span className="font-semibold">AI Prompt: </span>
				AI-driven extraction via custom prompts, without database verification.
			</Typography>
		</>
	);
};
